export default __webpack_public_path__ + "static/media/dmy3.ccab54c2.png";